import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const ChartSuccess = ({chartData}) => {
  const [series, setSeries] = useState([]);
  const [timeInterval, setTimeInterval] = useState([]);

  const [state, setState] = useState({
    series: [],
    options: {
      chart: {
        type: 'line',
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      markers: {
        size: 5,
      },
      colors: ["#009200", "#e10000"],
        title: {
        align: 'left'
      },
      grid: {
        row: {
          colors: ['#fff', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5
        },
      },
      xaxis: {
        categories: [],
      }
    },
  })

  useEffect(() => {
    setState({
      ...state,
      series: chartData?.seriesByStatus,
      options: {
        xaxis: {
          ...state.options.xaxis,
          categories: chartData?.timeInterval
        }
      }
    })
  },[chartData])


  return (
    <div className="chartSuccess">
      <div className="row">
        <div id="chart">
            {
              state?.series &&
              <ReactApexChart options={state.options} series={state.series} type="line" height={300}/>
            }
        </div>
        </div>
    </div>
  );
}

export default ChartSuccess;